<template>
  <v-tabs style="position: relative; max-width: 56px;" :hide-slider="true">
    <v-tab class="px-3 rounded-tab" :class="replaceKeysVisibleAndPresent ? 'flowout stickynote' : ''"
      style="min-width: unset;" :disabled="!hasReplaceKeywords" @click="ShowReplaceKeys = !ShowReplaceKeys">
      <v-icon size="20" :color="replaceKeysVisibleAndPresent ? 'tertiary' : 'rgba(0, 0, 0, 0.54)'">
        mdi-key-variant
      </v-icon>
    </v-tab>
  </v-tabs>
</template>


<script>

export default {
  name: 'ReplaceKeysButton',
  props: {
    replaceKeyWords: Array,
  },
  components: {},
  mixins: [],

  data() {
    return {
    };
  },

  methods: {},

  computed: {
    hasReplaceKeywords() {
      return this.replaceKeyWords && !!this.replaceKeyWords[0];
    },

    replaceKeysVisibleAndPresent() {
      return this.hasReplaceKeywords && this.ShowReplaceKeys;
    },

    ShowReplaceKeys: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("ShowReplaceKeys");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "ShowReplaceKeys", value: update });
      },
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>
    .rounded-tab.flowout.stickynote,
    .rounded-tab.flowout.stickynote::after {
      background-color: rgb(255, 246, 189) !important;
    }
</style>